import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Pagination from "@mui/material/Pagination";

const Wrap = styled("div")({
  display: "flex",
  justifyContent: "center",
});

let beforePageChange = null;
export function setBeforePageChange(cb) {
  beforePageChange = cb;
}

function MuiPaginationView({ current, totalPages, onChange }) {
  if (!totalPages || totalPages < 2) return null;
  return (
    <Wrap>
      <Pagination
        count={totalPages}
        page={current}
        onChange={(_e, p) => {
          if (typeof beforePageChange === "function") beforePageChange();
          onChange(p);
        }}
        shape="rounded"
        size="small"
        color="secondary"
        siblingCount={1}
        boundaryCount={1}
        sx={{
          "& .MuiPaginationItem-root": {
            fontSize: "0.75rem",
            minWidth: 24,
            height: 24,
            margin: "0 1px",
          },
        }}
      />
    </Wrap>
  );
}

MuiPaginationView.propTypes = {
  current: PropTypes.number,
  totalPages: PropTypes.number,
  onChange: PropTypes.func,
};

export default MuiPaginationView;
